import { Fragment } from "react";
import { formatName } from "../../../../utils/helpers/stringFormaters";

function FiReviewCard({ review = "", name = "", avatar = null, rate = 5 }) {
  name = formatName(name);
  // Use provided backend avatar URL or fall back to local SVG asset
  const avatarSrc =
    avatar || `${process.env.PUBLIC_URL}/images/avatar_settings.svg`;

  return (
    <div className="fi-review-card">
      <div className="fi-review-quote-icon">
        <img
          src={`${process.env.PUBLIC_URL}/images/quote_1F93FF.png`}
          style={{ width: "30px", height: "24px" }}
          alt="quote"
        />
      </div>

      <div className="fi-review-content">
        <p>{review}</p>
      </div>

      <div className="fi-review-user">
        <div className="fi-review-avatar">
          <img src={avatarSrc} alt={name} />
        </div>

        <div className="fi-review-meta">
          <p className="fi-review-user-name">{name}</p>

          <div className="product-review-rate">
            {[...Array(rate)].map((_, j) => (
              <img
                key={j}
                src={`${process.env.PUBLIC_URL}/images/icons/yellow_star.svg`}
                alt="star"
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FiReviewCard;
